angular.module('LeasePilot').directive('clausebookGapReport', [
  '$mdDialog',
  '$rootScope',
  'ApiService',
  function($mdDialog, $rootScope, ApiService) {
    return {
      restrict: 'E',
      templateUrl: 'clausebook_gap_report_menu_item.html',
      // Visibility is gated in the template on `isClausebookEnabled`, the flag
      // LeaseEditorController already derives from the form config in
      // `setLease` and that this same toolbar uses for the Clausebook pane.
      // Reading `$rootScope.lease` here instead would run at link time, which
      // is before `templatesReady:loadDocument` has loaded the document, so
      // the item would be hidden for every lease.
      link: function(scope) {
        scope.showClausebookGapReport = function() {
          const lease = $rootScope.lease;
          if (!lease) {
            return;
          }

          $mdDialog.show({
            skipHide: true,
            clickOutsideToClose: true,
            templateUrl: 'clausebook_gaps.html',
            controller: [
              '$scope',
              function(dialogScope) {
                dialogScope.loading = true;
                dialogScope.close = function() {
                  $mdDialog.cancel();
                };

                ApiService.clausebookGaps({ documentId: lease.id })
                  .then(function(response) {
                    dialogScope.report = response.data;
                  })
                  .catch(function() {
                    // "Try again." promised a retry this dialog does not have —
                    // its only control is Close. An instruction the UI cannot
                    // obey is worse than no instruction, so this names the one
                    // action available. Also drops the third name for this
                    // dialog: the aria-label and the heading both say coverage.
                    dialogScope.error =
                      'Clausebook coverage did not load. Close the report and open it again.';
                  })
                  .finally(function() {
                    dialogScope.loading = false;
                  });
              },
            ],
          });
        };
      },
    };
  },
]);
